import { FALLBACK_LANGUAGE } from '@muzly/shared/i18n';

import { toLanguage } from '@muzly/shared';

import type { Language } from '@muzly/shared/i18n';

/**
 * `<html lang>` 에 적을 값. 중국어는 문자 체계까지 적는다 — 한자는 한·중·일이 같은 코드를
 * 쓰고 자형만 달라, 브라우저가 간체 글꼴을 고르려면 `zh-Hans` 여야 한다.
 */
export const htmlLang = (language: Language): string =>
  language === 'zh' ? 'zh-Hans' : language;

type LanguageSource = {
  language: string;
  resolvedLanguage?: string;
  on: (event: 'languageChanged', listener: (language: string) => void) => void;
};

/**
 * 문서의 `lang` 을 화면 언어에 맞춘다 — `index.html` 의 `lang="ko"` 는 첫 그림일 뿐이다.
 * 스크린 리더의 발음, 브라우저의 글꼴·줄바꿈 선택, `styles.css` 의 `:lang(zh)` 규칙이
 * 이 값을 본다. i18n 초기화는 import 부작용으로 이미 끝났으므로 지금 값으로 한 번 맞추고
 * 그 뒤의 전환을 따라간다.
 */
export const syncDocumentLanguage = (
  i18n: LanguageSource,
  root: HTMLElement = document.documentElement,
): void => {
  const apply = (language: string | undefined): void => {
    root.lang = htmlLang(toLanguage(language) ?? FALLBACK_LANGUAGE);
  };
  apply(i18n.resolvedLanguage ?? i18n.language);
  i18n.on('languageChanged', apply);
};
